import React, { useState } from 'react'

import styled from 'styled-components'
import { v4 as uuidv4 } from 'uuid'

import i18n from 'live/services/i18n'

import { saveAllTemporaryData } from '../../importer-api'
import { emptyWell } from '../../utils/emptyEntities'
import { TemporarySetDataType } from '../useTemporaryDataState'
import ExportStaticDataModal from '../../../exporter/ExportStaticDataModal'

interface NoDataProps {
    setData: TemporarySetDataType
    setIsImportDataSideBarOpen: (value: boolean) => void
    hasPermissionToEdit: boolean
}

export const NoData = ({ setData, setIsImportDataSideBarOpen, hasPermissionToEdit }: NoDataProps): JSX.Element => {
    const [showExportModal, setShowExportModal] = useState<boolean>(false)

    const handleAddNewWell = () => {
        const newWell: WellDto = {
            ...emptyWell,
            key: undefined,
            parent: Date.now() - 10000,
            nodeId: Date.now(),
            rowId: undefined,
            frontUuid: uuidv4(),
            frontParentUuid: undefined
        }

        saveAllTemporaryData(newWell, 'WELL').then(saves => {
            newWell.rowId = saves[0].id
            newWell.key = saves[0].id
            setData.setWells([newWell])
        })
    }

    return (
        <>
            <NoDataContainer>
                <NoDataContent>
                    <i className="fal fa-exclamation-circle" />
                    <span className="no-data-title">{i18n('No data')}</span>
                    <span className="description">
                        {i18n('You can import or create static data entries for a well.')}
                    </span>
                    <div className="act-btns">
                        <button
                            className="import-data-btn"
                            onClick={() => setIsImportDataSideBarOpen(true)}
                            disabled={!hasPermissionToEdit}
                        >
                            <i className="fa fal fa-file-download" />
                            {i18n('Import data')}
                        </button>
                        <button className="import-data-btn" onClick={() => setShowExportModal(true)}>
                            <i className="fas fa-download" />
                            {i18n('Download Static Data')}
                        </button>
                        <button className="add-btn" onClick={() => handleAddNewWell()} disabled={!hasPermissionToEdit}>
                            <i className="fa fa-plus" />
                            {i18n('Create data')}
                        </button>
                    </div>
                </NoDataContent>
            </NoDataContainer>

            <ExportStaticDataModal show={showExportModal} setShow={setShowExportModal} />
        </>
    )
}

const NoDataContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    height: 100%;
`

const NoDataContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .fa-exclamation-circle {
        font-size: 64px;
        color: var(--blue-500);
    }

    .no-data-title {
        font-size: 16px;
        font-weight: 700;

        margin: 24px 0 8px;
    }

    .description {
        max-width: 300px;
        align-self: center;
        color: var(--gray-700);
    }

    .act-btns {
        display: flex;
        justify-content: center;
        gap: 8px;
        margin-top: 16px;

        button {
            display: flex;
            justify-content: center;
            align-items: center;
            align-self: center;
            gap: 8px;

            padding: 6px 8px;

            border: none;
            border-radius: 3px;

            font-size: 13px;
            font-weight: 700;

            &:hover {
                opacity: 0.8;
            }

            &:disabled {
                cursor: not-allowed;
                opacity: 0.6;
                &:hover {
                    opacity: 0.6;
                }
            }
        }

        .import-data-btn {
            border: 1px solid var(--blue-500);
            color: white;
            background-color: var(--blue-500);
        }

        .add-btn {
            border: 1px solid var(--gray-400);
            background-color: transparent;
        }
    }
`
